<template>
    <div>
        <Breadtabsheader/>
        <div class="h-content">
            <!--查询-->
            <div class="h-piece">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                    <div class="h-thirdColumn w-newColumn">

                        <el-form-item label="经销商名称">
                            <el-input  placeholder="请输入名称或编码" v-model="q.companyNameOrCode" :clearable="true"></el-input>
                        </el-form-item>

                        <el-form-item label="活动类型">
                            <el-select v-model="q.activityType"  placeholder="请选择" clearable>
                                <el-option label="高校巡展/实验室安全讲座演练" value="高校巡展/实验室安全讲座演练"></el-option>
                                <el-option label="渠道客户会/用户" value=渠道客户会/用户></el-option>
                                <el-option label="润心巡检" value="润心巡检"></el-option>
                                <el-option label="区域展会" value="区域展会"></el-option>
                                <el-option label="学术会" value="学术会"></el-option>
                            </el-select>
                        </el-form-item>


                    </div>
                </el-form>

                <div class="l-screenBox">
                    <div class="l-retrieval">
                        <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                        <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                        </el-button>
                        <el-button
                            class="h-btn h-formBtn h-bggreen" icon="el-icon-plus"
                            @click="createdActivity">新增推广活动
                        </el-button>
                    </div>
                </div>
            </div>
            <!--查询end-->

            <!--数据展示-->
            <div class="h-table h-mrt30">
                <el-table
                    ref="ddtable"
                    :data="tableData"
                    stripe
                    border
                    style="width: 100%">
                    <el-table-column
                        type="index"
                        width="60"
                        label="序号"
                        fixed >
                    </el-table-column>

                    <!-- 活动类型 -->
                    <el-table-column
                        prop="activityType"
                        label="活动类型"
                        :show-overflow-tooltip="true"
                        width="130"
                    >
                    </el-table-column>

                    <!-- 省市 -->
                    <el-table-column
                        prop="provinceCity"
                        label="省市"
                        :show-overflow-tooltip="true"
                        width="120"
                    >
                    </el-table-column>

                    <!-- 客户或经销名称 -->
                    <el-table-column
                        prop="companyName"
                        label="客户或经销名称"
                        :show-overflow-tooltip="true"
                        width="150"
                    >
                    </el-table-column>

                    <!-- 客户或经销商编码 -->
                    <el-table-column
                        prop="companyCode"
                        label="客户或经销商编码"
                        :show-overflow-tooltip="true"
                        width="160"
                    >
                    </el-table-column>

                    <!-- 提报人姓名 -->
                    <el-table-column
                        prop="reporterName"
                        label="提报人姓名"
                        :show-overflow-tooltip="true"
                        width="120"
                    >
                    </el-table-column>

                    <!-- 联系电话 -->
                    <el-table-column
                        prop="contactPhone"
                        label="联系电话"
                        :show-overflow-tooltip="true"
                        width="130"
                    >
                    </el-table-column>

                    <!-- 巡展高校（院系),润心单位 ,活动名称 -->
                    <el-table-column
                        prop="eventName"
                        label="活动名称"
                        :show-overflow-tooltip="true"
                        width="180"
                    >
                    </el-table-column>

                    <!-- 润心时间/活动时间/巡展时间 -->
                    <el-table-column
                        prop="eventTime"
                        label="活动时间"
                        :show-overflow-tooltip="true"
                        width="160"
                    >
                    </el-table-column>

                    <!-- 参与人数 -->
                    <el-table-column
                        prop="participantCount"
                        label="参与人数"
                        :show-overflow-tooltip="true"
                        width="100"
                    >
                    </el-table-column>

                    <!-- 交互用户信息 -->
                    <el-table-column
                        prop="interactionUsers"
                        label="交互用户信息"
                        :show-overflow-tooltip="true"
                        width="200"
                    >
                    </el-table-column>

                    <!-- 其他润心效果总结/其他会议效果总结/其他巡展效果总结 -->
                    <el-table-column
                        prop="mainSummary"
                        label="效果总结"
                        :show-overflow-tooltip="true"
                        width="180"
                    >
                    </el-table-column>

                    <!-- 总共发生费用 （高校，渠道会） -->
                    <el-table-column
                        prop="totalExpense"
                        label="总共发生费用"
                        :show-overflow-tooltip="true"
                        width="130"
                    >
                    </el-table-column>

                    <!-- 市场销售人员是否到场（润心) -->
                    <el-table-column
                        prop="salespersonPresent"
                        label="销售人员是否到场"
                        :show-overflow-tooltip="true"
                        width="150"
                    >
                    </el-table-column>

                    <!-- 润心产品及数量 (润心)-->
                    <el-table-column
                        prop="productQty"
                        label="产品及数量"
                        :show-overflow-tooltip="true"
                        width="140"
                    >
                    </el-table-column>

                    <!-- 需求及建议 (润心) -->
                    <el-table-column
                        prop="needsSuggestions"
                        label="需求及建议"
                        :show-overflow-tooltip="true"
                        width="140"
                    >
                    </el-table-column>


                    <el-table-column
                        prop="cdate"
                        label="创建日期"
                        :show-overflow-tooltip="true"
                        width="140">
                    </el-table-column>
                    <el-table-column
                        prop="cuname"
                        label="创建人"
                        width="80">
                    </el-table-column>

                    <!-- 修改时间 -->
                    <el-table-column
                        prop="ldate"
                        label="修改时间"
                        :show-overflow-tooltip="true"
                        width="160"
                    >
                    </el-table-column>

                    <!-- 修改人编码 -->
                    <el-table-column
                        prop="lucode"
                        label="修改人编码"
                        :show-overflow-tooltip="true"
                        width="120"
                    >
                    </el-table-column>

                    <el-table-column
                        fixed="right"
                        label="操作"
                        width="220" >
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                size="small"
                                class="h-tableLink h-btn"
                                @click="toSee(scope.row)">
                                查看
                            </el-button>
                            <el-button
                                type="text"
                                size="small"
                                @click="toChange(scope.row)"
                                class="h-tableLink h-btn"
                            >
                                修改
                            </el-button>
                            <el-button
                                type="text"
                                size="small"
                                plain
                                class="h-tableLink h-btn"
                                @click="todel(scope.row)">
                                删除
                            </el-button>

                        </template>
                    </el-table-column>
                </el-table>
                <div class="h-tableB h-mrt30">
                    <div class="h-tableBL">
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                   @click="exportExcel">批量导出</el-button>
                    </div>
                    <div class="h-pagination2">
                        <pagination :page="q" @query="query" />
                    </div>
                </div>
            </div>
            <!--数据展示end-->
        </div>
    </div>
</template>
<script>
import moment from "moment";
import weeklyMeetingApi from "@/api/loud/weeklyMeeting/weeklyMeetingApi";
import updownfile from "@/utils/updownfile";
import activityInfo from "@/api/loud/activity/activityInfo";
import ss from "@/api/SystemService";
export default {
    data(){
        return{
            // 展开折叠筛选
            isScreen:false,
            closeScreen:require("@/assets/images/pimg/closeallic.png"),
            drawScreen:require("@/assets/images/pimg/dobleArr.png"),
            q:{
                companyCode: null, //经销商编码
                companyName: null, //经销商名称
                companyNameOrCode: null, //经销商名称或编码
                activityType: null,//活动类型
                pageNo:1,
                pageSize: 10,
                total: 0,
            },

            tableData: [],
            currentTime: ''
        }
    },
    methods:{
        // 展开折叠
        collapseChange(){
            this.isScreen = !this.isScreen;
        },
        query(){
            console.log(this.q,'查询条件')
            activityInfo.selectPage(this.q).then(res=>{
                console.log(res)
                this.q.total = res.total
                this.tableData = res.records
            })
        },
        //检索
        handleFilter() {
            this.q.pageNo = 1;
            this.query();
        },
        resetData(){
            this.q = {
                pageNo:1,
                pageSize: 10,
                total: 0
            }
            this.query()
        },
        //新增活动
        createdActivity() {
            this.$router.push({path: "/activity/addActivity"});
        },
        //查看详情
        toSee(row){
            console.log(row)
            this.$router.push({path: "/activity/seeActivity",query:{id:row.id}});
        },
        //修改--当天申请的可以修改
        toChange(row){
            console.log(row)
            this.$router.push({path: "/activity/addActivity",query:{id:row.id}});
        },

        todel(row){

            this.$msg.confirm("是否确认删除?", () => {

                activityInfo.deleteById(row.id).then(res=>{
                    if (res.f){
                        this.$alert("删除成功", '提示', {
                            confirmButtonText: '确定',
                        });
                        this.query();
                    }else {
                        this.$msg.msge("删除失败!");
                    }

                })

            })
        },



     /*   printDetail(x){
            updownfile.down('/api/swyl/v1/demo/bscActivityInfo/downloadExcelDetail',{id:x},"get");
        },*/
        //批量导出
        exportExcel(){
            updownfile.down("/api/swyl/v1/demo/bscActivityInfo/downloadExcel", this.q, "get");
        }
    },
    created() {
        this.currentTime = moment(new Date()).format('YYYY-MM-DD')
        this.query()
    },
    activated() {
        this.query()
    }
}
</script>

